var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-imgs-container",style:({
    'margin-top': _vm.cc.margin_top + 'px' || _vm.gc.margin_top + 'px',
    'margin-bottom': _vm.cc.margin_bot + 'px' || _vm.gc.margin_bot + 'px',
    padding: _vm.cc.padding ? _vm.cc.padding + 'px 0' : '0',
    background: _vm.cc.mod_bg_img ? `url(${_vm.cc.mod_bg_img})` : '',
    'background-size': 'cover',
  })},[_c('div',{staticClass:"swiper-container",style:({
      'padding-left': _vm.cc.bg_space_left + 'px',
      'padding-top': _vm.padding_t_b[0] + 'px',
      'padding-bottom': _vm.padding_t_b[1] + 'px',
    })},[_c('div',{staticClass:"bg-container",style:({
        position: 'absolute',
        top: 0,
        left: 0,
        width: `${_vm.cc.bg_width}px`,
        height: `${_vm.cc.bg_height}px`,
        background: `${
          _vm.cc.bg_type == 'color' ? _vm.cc.bg_color : 'url(' + _vm.cc.bg_img + ')'
        } no-repeat`,
        'background-size': '100% 100%',
      })}),_c('div',{staticClass:"swiper main-swiper",style:({
        position: 'relative',
      })},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.list),function(item){return _c('div',{key:item.img,staticClass:"swiper-slide",style:({
            'box-sizing': 'content-box',
            width: _vm.cc.width_scale_screen + 'vw',
            'padding-right': _vm.cc.space + 'px',
          }),on:{"click":function($event){$event.stopPropagation();return _vm.jump(item)}}},[_c('img',{style:({
              'object-fit': 'cover',
            }),attrs:{"src":item.img,"alt":""}})])}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }